import {
  FETCH_WITHDRAWS,
  FETCH_WITHDRAWS_SUCCESS,
  FETCH_WITHDRAWS_FAILED,
  EDIT_WITHDRAWS
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { onValue, child, update, get, push, off } from "firebase/database";
import store from '../store/store';

const withdrawPatch = (processed, status, processDate) => ({
  processed,
  status,
  processDate,
});

export const fetchWithdraws = () => (dispatch) => {

  const {
    withdrawRef,
    withdrawListRef
  } = firebase;

  const profile = store.getState().auth.profile;
  const isAdmin = profile && profile.usertype === 'admin';
  const listRef = isAdmin
    ? withdrawRef
    : (profile && profile.uid ? withdrawListRef(profile.uid) : withdrawRef);

  dispatch({
    type: FETCH_WITHDRAWS,
    payload: null
  });

  off(listRef);
 onValue(listRef, snapshot => {
    if (snapshot.val()) {
      const data = snapshot.val();
      const arr = Object.keys(data).map(i => {
        data[i].id = i
        return data[i]
      });
      dispatch({
        type: FETCH_WITHDRAWS_SUCCESS,
        payload: arr.reverse()
      });
    } else {
      dispatch({
        type: FETCH_WITHDRAWS_FAILED,
        payload: "No WITHDRAWS available."
      });
    }
  });
};

// Marca un retiro como pagado (el saldo ya se descuento al solicitar).
export const completeWithdraw = (entry) => async (dispatch) => {
  const { withdrawRef } = firebase;

  if (!entry?.id) {
    throw new Error('missing_withdraw_id');
  }
  if (entry.status === 'paid' || entry.status === 'rejected' || entry.processed === true) {
    return;
  }

  dispatch({
    type: EDIT_WITHDRAWS,
    payload: entry
  });

  await update(
    child(withdrawRef, entry.id),
    withdrawPatch(true, 'paid', new Date().getTime())
  );
};

// Rechaza un retiro y devuelve el saldo retenido a la billetera del usuario.
export const rejectWithdraw = (entry) => async (dispatch) => {

  const {
    withdrawRef,
    singleUserRef,
    walletHistoryRef,
    settingsRef
  } = firebase;

  dispatch({
    type: EDIT_WITHDRAWS,
    payload: entry
  });

  try {
    if (entry.status === 'rejected' || entry.processed) return;

    const settingsdata = await get(settingsRef);
    const settings = settingsdata.val();
    const decimal = settings && settings.decimal ? settings.decimal : 2;

    const userSnap = await get(singleUserRef(entry.uid));
    if (userSnap.val()) {
      const current = parseFloat(userSnap.val().walletBalance || 0);
      const refunded = parseFloat((current + parseFloat(entry.amount)).toFixed(decimal));
      await update(singleUserRef(entry.uid), { walletBalance: refunded });
      await push(walletHistoryRef(entry.uid), {
        type: 'Credit',
        amount: parseFloat(entry.amount),
        date: new Date().getTime(),
        txRef: 'WithdrawRejected'
      });
    }

    await update(child(withdrawRef, entry.id), withdrawPatch(false, 'rejected', new Date().getTime()));
  } catch (error) {
    console.log('rejectWithdraw error', error);
    throw error;
  }
};

// Marca varios retiros como pagados (tras generar el archivo/PDF para el banco).
export const batchProcessWithdraws = (entries) => async (dispatch) => {

  const {
    withdrawRef
  } = firebase;

  const now = new Date().getTime();
  for (let i = 0; i < entries.length; i++) {
    const entry = entries[i];
    if (entry.processed || entry.status === 'rejected') continue;
    dispatch({ type: EDIT_WITHDRAWS, payload: entry });
    await update(child(withdrawRef, entry.id), withdrawPatch(true, 'paid', now));
  }
};
